import { CustomerType } from "features/customer/enums/customerType";
import { Commodity } from "features/shared/enums/commodity";
import { Nullable } from "features/shared/types/nullable";

export const getContractCategory = (
  customerType: CustomerType,
  commodity: Commodity
): Nullable<string> => {
  if (customerType && commodity) {
    if (commodity === Commodity.Electricity) {
      switch (customerType) {
        case CustomerType.Person:
          return "D";
        case CustomerType.Company:
          return "C";
        default:
          break;
      }
    } else if (commodity === Commodity.Gas) {
      switch (customerType) {
        case CustomerType.Person:
          return "PDO";
        case CustomerType.Company:
          return "PMO";
        default:
          break;
      }
    }
  }

  return null;
};
